import React, { Component } from 'react';
import About from './About';
import { Link } from 'react-router-dom';
import './css/App.css';

class FAQ extends Component {

  componentDidMount() {
  }

  render() {

    return (
      <div className="subpage">

        <h1 className="fix"><Link to="/">0xINFINITY</Link></h1>

        <div className="subpage-inner">
          <div className="posts">
            <h2>// FAQ</h2>

            <div className="post">
                <strong className="question">Q: Does this cost money?</strong>
                <p>You'll need some Ether (ETH) in your wallet to post...usually a few cents ($USD). There is a small "gas" fee that is charged by Etherum to use the network. This fee basically pays/incentivizes the miners to run the network and keep it secure. Gas fees go up and down based on how much traffic is on the network but they are generally pretty cheap.</p>
            </div>

            <div className="post">
                <strong className="question">Q: Where is it saved and how?</strong>
                <p>Every post is saved to an Ethereum <a href={"https://etherscan.io/address/"+window.to}>address</a> as a transaction. The text from your post is encoded and saved in the data field of the transaction. You can head over to <a href={"https://etherscan.io/address/"+window.to}>EtherScan.io</a> to see all posts.</p>
            </div>

            <div className="post">
                <strong className="question">Q: Forever? Uncensorable? Really?</strong>
                <p>Yes forever, at least for as long as the Ethereum network is running. And uncensorable in that no government can control a decentralized blockchain. Ethereum is the largest smart contracts cryptocurrency and only Bitcoin is larger. I anticipate it to be the blockchain that will be around in some form for a long long time.</p>
            </div>

            <div className="post">
                <strong className="question">Q: What is MetaMask?</strong>
                <p><a href="https://metamask.io">MetaMask</a> is a Google Chrome or Brave Browser extension that allows you to interface with the Ethereum network in browser. You can create a wallet and send/recieve money right in your browser and use that money to interface with dAPPs like this one. Yes, working with the blockchain is kind of a pain in the ass right now and isn't for noobs but this is where we are in the early days of decentralization.</p>
            </div>

            <div className="post">
                <strong className="question">Q: What about Coinbase Wallet?</strong>
                <p>If you use Coinbase to purchase Ether give their Coinbase Wallet app a try. It's a dAPP viewer that lets you load this site in a browser that is connected to your wallet.</p>
            </div>

            <div className="post">
                <strong className="question">Q: Where do I even get Ethereum?</strong>
                <p>You can purchase via <a href="https://www.coinbase.com/join/52e1c9bc5b9c89a300000008">Coinbase</a> through Metamask or via other sites like <a href="https://binance.com">Binance</a> or even the <a href="https://robinhood.com">Robinhood</a> app</p>
            </div>

            <div className="post">
                <strong className="question">Q: Why would I even need to post something anonymous and uncensorable?</strong>
                <p>Maybe you want to say something that lives on the internet forever. Maybe you live under a government that censors the internet and this is the only way to get the message out.</p>
            </div>

            <div className="post">
                <strong className="question">Q: I saw someone post something mean, racist, disgusting, and/or stupid. What can I do?</strong>
                <p>That sucks. 0xINFINITY isn't intended for that but there's nothing we can do as people can post whatever they want to the blockchian and we have no control over it.</p>
            </div>

            <div className="post">
                <strong className="question">Q: Why the name "OxINFINITY"?</strong>
                <p>Etherum wallet addresses start with "0x"..."INFINITY" because, the messages will be up for as long as the blockchain exists.</p>
            </div>

            <div className="post">
                <strong className="question">Q: Who made this thing?</strong>
                <p><a href="https://deleteyourself.com">Delete Yourself</a>...a post-internet internet company.</p>
            </div>

          </div>
          <About home={false}/>
        </div>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/FAQ.js